export type NotUndefined<T = unknown> = Exclude<T, undefined>;
export type NotNull<T = unknown> = Exclude<T, undefined>;

export type UndefinedToNull<T> = [T] extends [undefined] ? null : T;
export type NullToUndefined<T> = [T] extends [null] ? undefined : T;

export function undefinedToNull<T>(value: T): T;
export function undefinedToNull<T>(value: undefined): null;
// eslint-disable-next-line prettier/prettier
export function undefinedToNull<T extends NotUndefined>(value: T | undefined): T | null {
  return value === undefined ? null : value;
}

export function nullToUndefined<T>(value: T): T;
export function nullToUndefined<T>(value: null): undefined;
// eslint-disable-next-line prettier/prettier
export function nullToUndefined<T extends NotNull>(value: T | null): T | undefined {
  return value === null ? undefined : value;
}
